export const ERP_NAVIGATION_COMPONENT_CONFIG = {
  component: null,
};
